import React from 'react';

import { StyleSheet } from 'react-native';

import { Box, BoxProps } from 'components/ui';

export const ProductItemFlowContainer = ({ style, ...props }: BoxProps) => (
  <Box {...props} style={[styles.productItemFlowContainer, style]} />
);

const styles = StyleSheet.create({
  productItemFlowContainer: {
    width: '100%',
  },
});
